// Removing the last product from the cart asks first (popup from dialog.js, texts from
// wc-adjustments/cart.php). On the cart page that covers the remove link and every
// quantity set to 0; other places that remove from the cart call confirmRemoving().

import { confirmDialog } from './dialog';

// one remove link per line; bundle items have none and go with their bundle
const lineCount = () => document.querySelectorAll('.woocommerce-cart-form .product-remove > a').length;

const confirmEmptyCart = () => (window.sonCartEmptyConfirm
    ? confirmDialog(window.sonCartEmptyConfirm)
    : Promise.resolve(true));

// for cart changes made outside the cart table, e.g. the collection deal cards
export function confirmRemoving(productId) {
    const links = document.querySelectorAll('.woocommerce-cart-form .product-remove > a');
    const last = links.length === 1 && links[0].dataset.product_id === String(productId);

    return last ? confirmEmptyCart() : Promise.resolve(true);
}

document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('woocommerce-cart')) {
        return;
    }

    let asking = false;
    let allowed = false;

    const zeroedInputs = () => [...document.querySelectorAll('.woocommerce-cart-form input.qty')]
        .filter((input) => Number(input.value) === 0);

    const updateEmptiesCart = () => {
        const zeroed = zeroedInputs().length;
        return zeroed > 0 && zeroed >= lineCount();
    };

    const resetZeroed = () => zeroedInputs().forEach((input) => {
        input.value = input.defaultValue;
    });

    // Stops the event before Woo's handlers see it; on confirm, proceed() replays the action
    function confirmFirst(event, proceed, revert = () => {}) {
        event.preventDefault();
        event.stopPropagation();
        // the qty input's change fires a second update while the popup is open
        if (asking || !window.sonCartEmptyConfirm) {
            return;
        }

        asking = true;
        confirmEmptyCart().then((confirmed) => {
            asking = false;
            if (!confirmed) {
                revert();
                return;
            }
            allowed = true;
            proceed();
            allowed = false;
        });
    }

    // capture phase: runs before Woo's delegated jQuery handlers
    document.addEventListener('click', (event) => {
        if (allowed || !window.sonCartEmptyConfirm) {
            return;
        }

        const link = event.target.closest('.woocommerce-cart-form .product-remove > a');
        if (link && lineCount() === 1) {
            confirmFirst(event, () => link.click());
            return;
        }

        const update = event.target.closest(".woocommerce-cart-form [name='update_cart']");
        if (update && updateEmptiesCart()) {
            confirmFirst(event, () => update.click(), resetZeroed);
        }
    }, true);

    // Enter in a quantity field updates the cart without a button click
    document.addEventListener('keypress', (event) => {
        if (allowed || event.key !== 'Enter' || !event.target.matches('.woocommerce-cart-form input.qty') || !updateEmptiesCart()) {
            return;
        }

        confirmFirst(event, () => document.querySelector(".woocommerce-cart-form [name='update_cart']")?.click(), resetZeroed);
    }, true);
});
